// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = "https://vlglfujkbmtqaqgedkvt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZsZ2xmdWprYm10cWFxZ2Vka3Z0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjExMjE4MzcsImV4cCI6MjA3NjY5NzgzN30.aUk2n0RCPhXQl6f4s_cAiaBFEpXVIESt0sS2RQiBNRk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY
);
